module.exports = __webpack_public_path__ + "static/media/Slot-images.5de1cabe.jpeg";